import { render, staticRenderFns } from "./updatedBomProductQuantity.vue?vue&type=template&id=5bb93387"
import script from "./updatedBomProductQuantity.vue?vue&type=script&lang=js"
export * from "./updatedBomProductQuantity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports